var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoApm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-apm",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M29.256,23.872a2.207,2.207,0,0,1-1.572.651H9.805a2.391,2.391,0,0,1-2.329-2.934l2.577-11.056a8.829,8.829,0,0,1,17.278.025l2.344,10.118H27.394l-.2-.861-2.034-8.779a6.6,6.6,0,0,0-12.932-.023L9.641,22.094a.169.169,0,0,0,.164.207h20.1A2.2,2.2,0,0,1,29.256,23.872Zm-10,2.444h-1.29s-2.221,0-2.221,0a2.22,2.22,0,0,0,2.221,2.222h1.29a2.22,2.22,0,0,0,2.221-2.222S19.26,26.317,19.26,26.316Z",
    transform: "translate(-4.914 -2.506)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoApm);
export default __webpack_public_path__ + "static/media/ico-apm.d9dddef7dfa3a6825fa4df626418d579.svg";
export { ForwardRef as ReactComponent };